import {
  fetchCustomersPayloadType,
  fetchCustomersRepositoryPayloadType,
} from "../slices/customerSlice"

export const fetchCustomersService = ({
  payload,
}: fetchCustomersPayloadType) => {
  return {
    name: payload.customer ? payload.customer : undefined,
    status: payload.status || "active",
    page_no: payload.page + 1 || 1,
    page_size: payload.pageSize || 10,
  }
}

export const fetchCustomersRepositoryService = ({
  payload,
}: fetchCustomersRepositoryPayloadType) => {
  return {
    customer_name: payload.customer ? payload.customer : undefined,
    source:
      payload.source && payload.source !== "all" ? payload.source : undefined,
    page_no: payload.page + 1 || 1,
    page_size: payload.pageSize || 10,
    description: payload.description ? payload.description : undefined,
  }
}

export const getParam = (v: unknown): string | undefined =>
  Array.isArray(v) ? v[0] : typeof v === "string" ? v : undefined
